import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { EndpointRequest } from "../../pages/endpoint-requests/types";

interface EndpointRequestsState {
  requests: EndpointRequest[];
  isLoading: boolean;
  error: string | null;
}

const initialState: EndpointRequestsState = {
  requests: [],
  isLoading: false,
  error: null,
};

const endpointRequestsSlice = createSlice({
  name: "endpointRequests",
  initialState,
  reducers: {
    setRequests: (state, action: PayloadAction<EndpointRequest[]>) => {
      state.requests = action.payload;
      state.error = null;
    },
    addRequest: (state, action: PayloadAction<EndpointRequest>) => {
      state.requests.push(action.payload);
    },
    updateRequest: (
      state,
      action: PayloadAction<{ id: string; updates: Partial<EndpointRequest> }>
    ) => {
      const index = state.requests.findIndex((r) => r.id === action.payload.id);
      if (index !== -1) {
        state.requests[index] = {
          ...state.requests[index],
          ...action.payload.updates,
          updatedAt: new Date().toISOString(),
        };
      }
    },
    deleteRequest: (state, action: PayloadAction<string>) => {
      state.requests = state.requests.filter((r) => r.id !== action.payload);
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    clearRequests: (state) => {
      state.requests = [];
      state.error = null;
    },
  },
});

export const {
  setRequests,
  addRequest,
  updateRequest,
  deleteRequest,
  setLoading,
  setError,
  clearRequests,
} = endpointRequestsSlice.actions;

export default endpointRequestsSlice.reducer;
